import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { performAction } from '@app/actions/customizeActions';

import Button from '@components/buttons/Button';
import './RotateTool.scss';
import useIntlMessage from '@app/hooks/use-intl-message';

const RotateTool = ({ performAction }) => {
  const [rotateLeftTitleAriaLabel, rotateRightTitleAriaLabel] = useIntlMessage(
    'qau-art-rotate-left-aria-label',
    'qau-art-rotate-right-aria-label',
  );
  const rotateArt = ({ target }) => {
    const clockWise = target.classList.contains('cw');
    performAction('fieldRotate', {
      deg: clockWise ? 90 : -90,
    });
  };

  return (
    <div id="qau-rotate-tool">
      <div className="rotate-tool-title">
        <LocalizedText id="qau-rotate-art-tool-text" />
      </div>
      <div className="rotate-tool-button-group">
        <Button className="rotate-btn cw" onClick={rotateArt} aria-label={rotateLeftTitleAriaLabel} />
        <Button className="rotate-btn ccw" onClick={rotateArt} aria-label={rotateRightTitleAriaLabel} />
      </div>
    </div>
  );
};

RotateTool.propTypes = {
  performAction: PropTypes.func.isRequired,
};

export default connect(null, { performAction })(RotateTool);
